import styled from "styled-components";


export const LoginWrapper = styled.div`
  .or-separator {
    position: relative;
    &::before,
    &::after {
      content: "";
      flex: 1;
      border-bottom: 2px solid var(--borderLight);
    }

    &::before {
      margin-right: 10px;
    }

    &::after {
      margin-left: 10px;
    }
  }
  .authCol{
    min-height: 100vh;
    background-color: var(--white);
    padding-left: 1rem ;
    padding-right: 1rem ;
  }
  .logSignInner{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    /* padding-top: 30px; */
    padding-top: 105px;
  }

`;
